import React, { useContext } from 'react';
import { style } from 'typestyle';
import { useTranslation } from 'react-i18next';
import * as styles from '../check-in-employees.styles';
import type AgendaEntryParking from '../models/agenda-entry-parking';
import AgendaEntryParkingCard from '../cards/agenda-entry-parking-card.component';
import ActivityIndicator from '../../../core/components/activity-indicator/activity-indicator.component';
import { Center } from '../../../core/components/center/center.component';
import Column from '../../../core/components/column/column.component';
import { IsMobileContext } from '../../../core/context/is-mobile';
import StyleConstants from '../../../core/styles.constants';
import Grid from '../../../core/components/grid/grid.component';
import { DayPart } from '../models/daypart-entry';

interface Props {
  readonly parkings: AgendaEntryParking[] | undefined;
  readonly dayPart: DayPart;
  readonly selectedParking: AgendaEntryParking | undefined;
  readonly onParkingSelectionChanged: (parking: AgendaEntryParking, dayPart: DayPart) => void;
}

const AgendaEntryParkingGroup = ({ parkings, dayPart, selectedParking, onParkingSelectionChanged }: Props): React.JSX.Element => {
  const isMobile = useContext(IsMobileContext);
  const { t } = useTranslation();

  return (
    <div className={style(styles.sectionCard(isMobile))}>
      <Column>
        <span className={style(styles.columnHeader(isMobile))}>{t('parking-spots')}</span>
        {((): React.JSX.Element => {
          if (parkings == null) {
            return (
              <Center>
                <ActivityIndicator size={20} color={StyleConstants.GREY_COLOR} />
              </Center>
            );
          }

          if (parkings.length === 0) {
            return <span className={style(styles.emptyListMessage)}>{t('no-parking-spots-available')}</span>;
          }

          return (
            <Grid
              rowClass={style(styles.gridRow)}
              numberOfColumns={isMobile ? 1 : 3}
              itemSpacing={12}
              numberOfItems={parkings.length}
              renderItem={(index): React.JSX.Element => {
                const parking = parkings[index];
                return (
                  <div className={isMobile ? style(styles.rowItem(true)) : undefined} key={parking.id}>
                    <AgendaEntryParkingCard
                      parking={parking}
                      dayPart={dayPart}
                      onClick={onParkingSelectionChanged}
                      isSelected={parking.id === selectedParking?.id}
                    />
                  </div>
                );
              }}
            />
          );
        })()}
      </Column>
    </div>
  );
};

export default AgendaEntryParkingGroup;
